import { worldViewerWindow } from '../const';
import { getGyroActiveToggle, getVideoGainNode, setGyroActiveToggle } from './dataOps';
import { getVideo } from './domOps';
import { requestToToggleActivateGyro } from './moduleCaller';
/**
 * @remarks
 * Videoの音声をセット
 * @param volume {number}
 */ export const hel_video_SetVolume = (volume)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    const gainNode = getVideoGainNode();
    if (gainNode === undefined) {
        // iOS/Mac以外ではgainNodeが生成されていなくてundefinedになるため、直接video要素に設定する
        video.volume = volume;
        return;
    }
    //	worldViewerWindow.g_Video.volume = volume;
    gainNode.gain.value = volume;
};
const toggleGyroActive = ()=>{
    setGyroActiveToggle(!getGyroActiveToggle());
    requestToToggleActivateGyro();
    return getGyroActiveToggle();
};
/**
 * @remarks
 * ジャイロを変更
 * XRWorldIngame, JRWorld_web, WorldViewerにて未使用
 */ worldViewerWindow.toggleGyroActiveRequest = ()=>{
    if (getGyroActiveToggle()) {
        toggleGyroActive();
        return;
    }
    if (DeviceOrientationEvent && DeviceOrientationEvent.requestPermission && typeof DeviceOrientationEvent.requestPermission == 'function') {
        DeviceOrientationEvent.requestPermission().then((permissionState)=>{
            if (permissionState === 'granted') {
                toggleGyroActive();
            }
        }).catch(console.error);
    } else {
        toggleGyroActive();
    }
};
